import { gql } from '@apollo/client';
import { useParams } from 'react-router-dom';
import { ApolloQueryResult } from '@apollo/client';
import { useQuery } from '@/hooks/graphql/useQuery';
import { ReportName } from '../types';
import { REPORT_MAP } from '../consts';

const generateQuery = (reportName: ReportName) => gql`
  query regularHealthCheckupReportPdf($id: ID!) {
    client {
      regularHealthCheckupReport(id: $id) {
        ${reportName}
        ${reportName}Url
      }
    }
  }
`;

interface ShowReportParams {
  id: string;
}

type Report = {
  name: string;
  data: string;
  url: string;
};

type UseReport = (reportName: ReportName) => {
  report: Report | undefined;
  loading: boolean;
  refetch: () => Promise<ApolloQueryResult<unknown>>;
};

export const useReport: UseReport = reportName => {
  const { id } = useParams<ShowReportParams>();
  const { data, loading, refetch } = useQuery(generateQuery(reportName), {
    variables: { id: parseInt(id, 10) },
    fetchPolicy: 'no-cache'
  });

  if (loading) {
    return {
      report: undefined,
      loading,
      refetch
    };
  }

  return {
    report: {
      name: REPORT_MAP[reportName],
      data: data.client.regularHealthCheckupReport[reportName],
      url: data.client.regularHealthCheckupReport[`${reportName}Url`]
    },
    loading,
    refetch
  };
};
